import { Route } from "@angular/router";
import { EstornosPage } from "./estornos.page";

export const EstornosRouter: Route[] = [
  { path: 'estornos', component: EstornosPage }
];
